import type {
  MediaFile,
  PostCardHandlers,
  PostCardIds,
  PostCardMeta,
  PostCardStatus,
  PostCardViewModel,
} from "@/components/common/PostCard";
import { convertTimezoneToLocal } from "@/lib/utils/dateUtils";

interface BuildPostCardAuthor {
  name: string;
  id?: number;
  avatarUrl?: string | null;
}

interface BuildPostCardContent {
  body: string;
  studyGroupName?: string;
  files?: MediaFile[];
}

export interface BuildPostCardViewModelOptions {
  ids: PostCardIds;
  author: BuildPostCardAuthor;
  timestamp: string;
  content: BuildPostCardContent;
  status?: Partial<PostCardStatus>;
  handlers?: Partial<PostCardHandlers>;
}

export const buildPostCardViewModel = ({
  ids,
  author,
  timestamp,
  content,
  status = {},
  handlers = {},
}: BuildPostCardViewModelOptions): PostCardViewModel => {
  const meta: PostCardMeta = {
    author: author.name,
    authorId: author.id,
    timestamp,
    avatarUrl: author.avatarUrl ?? null,
    content: content.body,
    studyGroupName: content.studyGroupName,
    files: content.files,
  };

  return {
    meta,
    ids,
    status,
    handlers,
  };
};

export const formatPostTimestampFromUtc = (createdAt?: string): string => {
  if (!createdAt) return "";
  const { date, time } = convertTimezoneToLocal(createdAt, "UTC");
  if (!date || !time) return createdAt;
  return `${date} ${time}`;
};
